// Mock data for The Matrix Unlocked application page clone
// All submissions are stored in localStorage until backend is integrated

export const ASSETS = {
  logoEmblem:
    "https://framerusercontent.com/images/ZFVjHOTRNSdN9Ak81SO8PyLC60.png?width=386&height=416",
  logoEmblemDark:
    "https://framerusercontent.com/images/zSPaiHHiauaKK1BYT8nvCtl5KpQ.png?width=386&height=416",
  logoWordmark:
    "https://framerusercontent.com/images/nYYqCSiiA9cKLbMV98NkxDGzg4.png?width=1176&height=416",
  typeformLogo: "https://images.typeform.com/images/NrosgGgtxxwl",
  avatarsStrip:
    "https://framerusercontent.com/images/lp2seP0sarvwpw5fWU3Y73iqzQg.png?width=2220&height=595",
  playIcon:
    "https://framerusercontent.com/images/qZs3aQvIPI9oG1LULv7siPq70.svg?width=25&height=25",
  videoThumb:
    "https://framerusercontent.com/images/TLhvbbmx9a03cjQxw1k4dNxYs.png?width=1280&height=674",
  phoneLeft:
    "https://framerusercontent.com/images/6JSG06oUo6lAeLWp8gbFACbvEIU.png?width=600&height=1200",
  phoneRight:
    "https://framerusercontent.com/images/dq9D8NKqd0mOMfFfrw4KgiVxacI.png?width=600&height=1200",
  founder:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/1pcrfsj8_2026-09-11%2012.27.21.jpg",
  frankPortrait:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/m3pi1ksw_IMG_3458.webp",
  coaching:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/9ruszds4_Frank%20W_%20Karl%20%281%29.jpeg",
  groupEvent:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/g5jtmltc_Miami%20Group%20Image.JPG",
  tradeExec1:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/52za7z02_1%20%285%29.webp",
  tradeExec2:
    "https://customer-assets-0z36b82j.emergentagent.net/job_images-149/artifacts/psqv5agk_2%20%281%29.webp",
};

// Country flag shown under each testimonial video (as on the original site)
const FLAG_US =
  "https://framerusercontent.com/images/TLhvbbmx9a03cjQxw1k4dNxYs.png?width=1280&height=674";

// All 10 video testimonials from the original site (order preserved)
// poster = the video's own cover frame; flag = country flag under the video
export const TESTIMONIALS = [
  {
    id: 1,
    name: "Carlos",
    role: "TRADER",
    videoId: "tpKJoM9dCAGQJk55",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/vL5W1fyAT3ye7MaA/303433/276835__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 2,
    name: "Charles",
    role: "ENGINEER",
    videoId: "xOJtGHv7QIkDNP8w",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/5gmZUPAbr85HGWd2/303438/276841__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag:
      "https://framerusercontent.com/images/opeHgrVeFlOf3lRVKtgsVPtFeiM.png?width=1280&height=640",
  },
  {
    id: 3,
    name: "Lena",
    role: "TRADER",
    videoId: "R60H_1DURj4ieVrT",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/_LSmnnxrMMnvauxF/303432/276834__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.92,
    flag: FLAG_US,
  },
  {
    id: 4,
    name: "Tahir",
    role: "ENTREPRENEUR",
    videoId: "KhvuVEXsQgPFyTg_",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/V6a9olnu6un3GD72/303441/276845__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag:
      "https://framerusercontent.com/images/9V8NtzASUk8QGlSKp0GGVe31uaU.png?width=1280&height=640",
  },
  {
    id: 5,
    name: "Alex",
    role: "TECHNICAL MANAGER",
    videoId: "YJVe7FEj3i5hNqa9",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/J0MtiHtNBWo6oio8/303442/276846__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 6,
    name: "Lena & Simon",
    role: "TRADER",
    videoId: "kQfiulzxBAptd5w4",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/UQF0UV4kVoxGAzBk/303435/276836__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 7,
    name: "Jason",
    role: "ARMY VETERAN",
    videoId: "ue0SMVqOoLeXZg5c",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/Ds96AeFqpcAgpOhD/303443/276847__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 8,
    name: "Kurtis",
    role: "STAY AT HOME DAD",
    videoId: "nIOvpWS9GgPN6Q_x",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/ZOx64I07JY8GPS_I/303444/276848__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 9,
    name: "Fabian",
    role: "TRUCK DRIVER",
    videoId: "a8o_2jg9O9m8K434",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/3Tn6tAGECxMHma5y/303447/276851__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
  {
    id: 10,
    name: "Roy",
    role: "TRADER",
    videoId: "4xgeF3WFhucZ5gwE",
    poster:
      "https://fast.vidalytics.com/video/05PByEt0/jri1eHvFoi_9tQmN/303436/276837__FFMPEG/thumb/thumbnail-5_0.jpg",
    ratio: 177.78,
    flag: FLAG_US,
  },
];

// Student result screenshots (non-video testimonials, shown under the CTA)
export const RESULT_SCREENSHOTS = [
  "https://framerusercontent.com/images/pPL0ib4lUCJdpPFRKvUnn1l4x0.jpg?width=895&height=1234",
  "https://framerusercontent.com/images/Rotaw1ENCynrw8VyekaSY2imyks.png?width=786&height=1159",
  "https://framerusercontent.com/images/XhLtPYaA211tyFxiraMt8RejGE.png?width=618&height=806",
  "https://framerusercontent.com/images/Fn4znm7xQAm2zGtts1AgzmlAnI.png?width=597&height=948",
  "https://framerusercontent.com/images/AbZjuEYJQ1nK4tQ0DklQrtjEhg.png?width=1041&height=1180",
  "https://framerusercontent.com/images/SKHeoYrU4zEg3hqt6JkKAm8.png?width=1242&height=952",
  "https://framerusercontent.com/images/P5FiaMnIRxqP9vr0pBX1kMoLMg.png?width=550&height=1191",
  "https://framerusercontent.com/images/g5nxgCOmr1YVO0vffEYoXCLKw.png?width=732&height=851",
  "https://framerusercontent.com/images/0LLfnT4gzv6DViiJWSCZRaGyZg.png?width=616&height=1110",
  "https://framerusercontent.com/images/mApQ6XfO43opRnXdb26xmdGFSQ.png?width=940&height=473",
  "https://framerusercontent.com/images/NkQuW8o2P0GuiS2JG9BzeS1Z8.png?width=968&height=897",
  "https://framerusercontent.com/images/bSabMICvNx4ALruF5Q0E1y6inXQ.jpg?width=960&height=536",
  "https://framerusercontent.com/images/zhgvQ17gWdiJ7vAIIvEzI5P8X4U.jpg?width=681&height=620",
  "https://framerusercontent.com/images/V9WofB7zR7zaB3oPb7kgh9MNFY.png?width=740&height=1073",
  "https://framerusercontent.com/images/G14aiPNpOBQGybOq9woNE7AH5aY.jpg?width=692&height=714",
];

// Written reviews (non-video testimonials, shown under the CTA)
export const WRITTEN_REVIEWS = [
  {
    name: "Angry Mark",
    text: "Frank is amazing and such knowledgeable content",
  },
  {
    name: "Alexzander Gosling",
    text: "After following Frank\u2019s public work closely for the past eight months and uncovering countless hidden gems along the way, I finally decided to join his community \u2014 driven purely by curiosity about what might lie beyond what\u2019s shared publicly.",
  },
  {
    name: "Akann",
    text: "I really like the idea of knowing how to trade without spending my life in front of charts, I am adapted to this way of trading, I trade to live not live to trade, I am more than a trader. If you study all the content you will be ready to go to the market, the only dow...",
  },
  {
    name: "Yohan Sanon",
    text: "I validated my funded 1week after joining . The insight you get is magic",
  },
  {
    name: "Chawayne Bromfield",
    text: "This made things sooo better i can focus more on the charts nuff respect",
  },
  {
    name: "Matthew Stein",
    text: "Best decisions for my trading has been being a part of this community!",
  },
  {
    name: "Omar Ali",
    text: "These guys got something really special for sure super undervalued if you ask me!",
  },
  {
    name: "PrincePea34",
    text: "This information is next level. Can't wait to fully understand everything but what I have comprehended so far is amazing for my trading.",
  },
  {
    name: "Muhammad",
    text: "Excellent content. Great framework to connect all the important elements together to come up with sucessfull strategy.",
  },
  {
    name: "Leonard",
    text: "Really good content. He explain the things in a very structured and logic way, so I understand the topics really good. Much content to consume, but no but no unnecessary content.",
  },
  {
    name: "Miguel Jara",
    text: "It's amazing thanks for all I'm learn to Time and Price cycles thanks Frank",
  },
  {
    name: "William M Pollard",
    text: "The lessons taught in TMU are the best. You can't go wrong if you decide to join.",
  },
  {
    name: "MICHAEL",
    text: "A true Blessing to be Chosen to find this path. Trust in the process of becoming and trust in the voices who have already been there to guide you. #JahBless",
  },
  {
    name: "Haydo",
    text: "Thank-you Frank and team !!",
  },
  {
    name: "Gareth Pegler",
    text: "Good indicator, can't wait to put it to use.",
  },
  {
    name: "Joe T.A Harbz",
    text: "Always Learning!",
  },
  {
    name: "Alik",
    text: "Nice!!! The insight you get from the Time and Price cycles is next level.",
  },
];

// Exact replica of Typeform OSu1qHKV structure
export const FORM_STEPS = [
  {
    id: "contact",
    number: 1,
    title: "First, Your Contact Details",
    description: "Enter your contact information to continue.",
    fields: [
      {
        id: "full_name",
        label: "Full Name",
        description: "Include your First & Last Name",
        type: "short_text",
        placeholder: "Type your answer here...",
        required: true,
      },
      {
        id: "email",
        label: "Email",
        description:
          "Fill in your email address to receive updates on your application and much more",
        type: "email",
        placeholder: "name@example.com",
        required: true,
      },
      {
        id: "phone",
        label: "Your Phone Number",
        description:
          "Fill in your active phone number to receive updates on your application",
        type: "phone_number",
        placeholder: "(201) 555-0123",
        required: true,
      },
    ],
  },
  {
    id: "trading_profile",
    number: 2,
    title: "Your Trading Profile",
    description: "Tell us about your experience and what you're aiming for",
    fields: [
      {
        id: "trading_experience",
        label: "Trading experience",
        description: "Select where you are within your trading journey",
        type: "dropdown",
        placeholder: "Type or select an option",
        required: true,
        choices: ["Beginner", "Intermediate", "Advanced", "Expert"],
      },
      {
        id: "trading_goals",
        label: "Trading Goals",
        description: "Select what your goal in trading is",
        type: "dropdown",
        placeholder: "Type or select an option",
        required: true,
        choices: [
          "Trade full-time",
          "Build a second income",
          "Grow my existing account",
          "Finally become consistent",
          "Stop losing money",
        ],
      },
      {
        id: "income_goal",
        label: "Income Goal",
        description: "Select your income goal with trading",
        type: "dropdown",
        placeholder: "Type or select an option",
        required: true,
        choices: ["$5K-10K", "$10K-25K", "$25K-50K", "$50K-100K", "$100K+"],
      },
    ],
  },
  {
    id: "starting_point",
    number: 3,
    title: "Your Starting Point",
    description: "What you're working with today, and when you want to begin",
    fields: [
      {
        id: "portfolio_size",
        label: "Portfolio & Saving Size (USD)",
        description: "Outline your Portfolio & Saving Size",
        type: "dropdown",
        placeholder: "Type or select an option",
        required: true,
        choices: [
          "$0-5k",
          "$5-10k",
          "$10-20k",
          "$20-50k",
          "$50-100k",
          "$100-250k",
          "$250-500k",
          "$500k+",
        ],
      },
      {
        id: "start_timeline",
        label: "How soon are you looking to start?",
        description: "Select when you are ready to Unlock The Matrix",
        type: "dropdown",
        placeholder: "Type or select an option",
        required: true,
        choices: [
          "Immediately",
          "Within a month",
          "Within 3 months",
          "Just exploring",
        ],
      },
    ],
  },
  {
    id: "schedule_call",
    number: 4,
    title: "Schedule your Enrollment Call",
    description: "See if you qualify to become part of The Matrix Unlocked.",
    type: "scheduler",
  },
];

// Comprehensive country dial-code list (ISO2 | dial | name), flags derived
// from the ISO code so they always match. Order = common countries first.
const COUNTRY_DIALS =
  "US|1|United States;CA|1|Canada;GB|44|United Kingdom;IE|353|Ireland;" +
  "AU|61|Australia;NZ|64|New Zealand;IN|91|India;SG|65|Singapore;" +
  "AE|971|United Arab Emirates;SA|966|Saudi Arabia;QA|974|Qatar;KW|965|Kuwait;" +
  "BH|973|Bahrain;OM|968|Oman;IL|972|Israel;TR|90|Turkey;" +
  "DE|49|Germany;FR|33|France;NL|31|Netherlands;BE|32|Belgium;" +
  "LU|352|Luxembourg;CH|41|Switzerland;AT|43|Austria;ES|34|Spain;" +
  "PT|351|Portugal;IT|39|Italy;GR|30|Greece;SE|46|Sweden;NO|47|Norway;" +
  "DK|45|Denmark;FI|358|Finland;IS|354|Iceland;PL|48|Poland;CZ|420|Czechia;" +
  "SK|421|Slovakia;HU|36|Hungary;RO|40|Romania;BG|359|Bulgaria;HR|385|Croatia;" +
  "SI|386|Slovenia;RS|381|Serbia;UA|380|Ukraine;RU|7|Russia;EE|372|Estonia;" +
  "LV|371|Latvia;LT|370|Lithuania;CY|357|Cyprus;MT|356|Malta;" +
  "MX|52|Mexico;BR|55|Brazil;AR|54|Argentina;CL|56|Chile;CO|57|Colombia;" +
  "PE|51|Peru;VE|58|Venezuela;EC|593|Ecuador;UY|598|Uruguay;PY|595|Paraguay;" +
  "BO|591|Bolivia;CR|506|Costa Rica;PA|507|Panama;DO|1|Dominican Republic;" +
  "GT|502|Guatemala;JM|1|Jamaica;TT|1|Trinidad and Tobago;" +
  "ZA|27|South Africa;NG|234|Nigeria;KE|254|Kenya;GH|233|Ghana;EG|20|Egypt;" +
  "MA|212|Morocco;DZ|213|Algeria;TN|216|Tunisia;ET|251|Ethiopia;" +
  "UG|256|Uganda;TZ|255|Tanzania;ZM|260|Zambia;ZW|263|Zimbabwe;CM|237|Cameroon;" +
  "CI|225|Cote d'Ivoire;SN|221|Senegal;AO|244|Angola;" +
  "CN|86|China;JP|81|Japan;KR|82|South Korea;HK|852|Hong Kong;TW|886|Taiwan;" +
  "TH|66|Thailand;VN|84|Vietnam;PH|63|Philippines;ID|62|Indonesia;MY|60|Malaysia;" +
  "PK|92|Pakistan;BD|880|Bangladesh;LK|94|Sri Lanka;NP|977|Nepal;KH|855|Cambodia;" +
  "MM|95|Myanmar;KZ|7|Kazakhstan";

const isoToFlag = (iso) =>
  iso
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));

// Example national-format phone number per country (what a local user types).
const PHONE_EXAMPLES = {
  US: "(201) 555-0123", CA: "(506) 234-5678", GB: "07400 123456",
  IE: "085 012 3456", AU: "0412 345 678", NZ: "021 123 4567",
  IN: "081234 56789", SG: "8123 4567", AE: "050 123 4567",
  SA: "050 123 4567", QA: "3312 3456", KW: "500 12345", BH: "3600 1234",
  OM: "9212 3456", IL: "050 123 4567", TR: "0501 234 56 78",
  DE: "0151 23456789", FR: "06 12 34 56 78", NL: "06 12345678",
  BE: "0470 12 34 56", LU: "628 123 456", CH: "078 123 45 67",
  AT: "0664 123456", ES: "612 34 56 78", PT: "912 345 678",
  IT: "312 345 6789", GR: "691 234 5678", SE: "070 123 45 67",
  NO: "406 12 345", DK: "20 12 34 56", FI: "041 2345678",
  IS: "611 1234", PL: "512 345 678", CZ: "601 123 456",
  SK: "0912 123 456", HU: "06 20 123 4567", RO: "0712 345 678",
  BG: "048 123 456", HR: "091 234 5678", SI: "031 234 567",
  RS: "060 1234567", UA: "050 123 4567", RU: "8 912 345-67-89",
  EE: "5123 4567", LV: "21 234 567", LT: "8 612 34567",
  CY: "96 123456", MT: "9696 1234",
  MX: "55 1234 5678", BR: "(11) 91234-5678", AR: "011 15-2345-6789",
  CL: "9 6123 4567", CO: "301 2345678", PE: "912 345 678",
  VE: "0412 1234567", EC: "099 123 4567", UY: "094 231 234",
  PY: "0961 456789", BO: "71234567", CR: "8312 3456",
  PA: "6123 4567", DO: "(809) 234-5678", GT: "5123 4567",
  JM: "(876) 210-1234", TT: "(868) 291-1234",
  ZA: "071 123 4567", NG: "0802 123 4567", KE: "0712 123456",
  GH: "023 123 4567", EG: "0100 123 4567", MA: "0650-123456",
  DZ: "0551 23 45 67", TN: "20 123 456", ET: "091 123 4567",
  UG: "0712 345678", TZ: "0621 234 567", ZM: "0955 123456",
  ZW: "071 234 5678", CM: "6 71 23 45 67", CI: "01 23 45 67",
  SN: "70 123 45 67", AO: "923 123 456",
  CN: "131 2345 6789", JP: "090-1234-5678", KR: "010-1234-5678",
  HK: "5123 4567", TW: "0912 345 678", TH: "081 234 5678",
  VN: "091 234 56 78", PH: "0917 123 4567", ID: "0812 345 678",
  MY: "012-345 6789", PK: "0301 2345678", BD: "01812-345678",
  LK: "071 234 5678", NP: "984-1234567", KH: "091 234 567",
  MM: "09 212 3456", KZ: "8 771 000 9998",
};

export const COUNTRY_CODES = COUNTRY_DIALS.split(";").map((row) => {
  const [code, dial, name] = row.split("|");
  return {
    code,
    dial: `+${dial}`,
    flag: isoToFlag(code),
    name,
    example: PHONE_EXAMPLES[code] || "123 456 789",
  };
});

// Time slots for the Calendly-style scheduler (step 4)
export const TIME_SLOTS = [
  "09:00 AM",
  "09:30 AM",
  "10:00 AM",
  "10:30 AM",
  "11:00 AM",
  "11:30 AM",
  "01:00 PM",
  "01:30 PM",
  "02:00 PM",
  "02:30 PM",
  "03:00 PM",
  "03:30 PM",
  "04:00 PM",
  "04:30 PM",
];

// MOCK submit - stores application in localStorage (replaced by backend later)
export const mockSubmitApplication = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const existing = JSON.parse(
        localStorage.getItem("tmu_applications") || "[]"
      );
      const application = {
        ...data,
        id: `app_${Date.now()}`,
        submitted_at: new Date().toISOString(),
      };
      existing.push(application);
      localStorage.setItem("tmu_applications", JSON.stringify(existing));
      resolve({ success: true, application });
    }, 800);
  });
};

// Flattened questions: one question per slide, auto-advance on selection
export const FORM_QUESTIONS = [
  {
    number: 1,
    id: "full_name",
    type: "short_text",
    title: "Full Name",
    description: "Include your First & Last Name",
    placeholder: "Type your answer here...",
  },
  {
    number: 2,
    id: "email",
    type: "email",
    title: "Email",
    description:
      "Fill in your email address to receive updates on your application and much more",
    placeholder: "name@example.com",
  },
  {
    number: 3,
    id: "phone",
    type: "phone_number",
    title: "Your Phone Number",
    description:
      "Fill in your active phone number to receive updates on your application",
    placeholder: "(201) 555-0123",
  },
  {
    number: 4,
    id: "trading_experience",
    type: "choices",
    title: "Trading experience",
    description: "Select where you are within your trading journey",
    choices: ["Beginner", "Intermediate", "Advanced", "Expert"],
  },
  {
    number: 5,
    id: "trading_goals",
    type: "choices",
    title: "Trading Goals",
    description: "Select what your goal in trading is",
    choices: [
      "Trade full-time",
      "Build a second income",
      "Grow my existing account",
      "Finally become consistent",
      "Stop losing money",
    ],
  },
  {
    number: 6,
    id: "income_goal",
    type: "choices",
    title: "Income Goal",
    description: "Select your income goal with trading",
    choices: ["$5K-10K", "$10K-25K", "$25K-50K", "$50K-100K", "$100K+"],
  },
  {
    number: 7,
    id: "portfolio_size",
    type: "choices",
    title: "Portfolio & Saving Size (USD)",
    description: "Outline your Portfolio & Saving Size",
    choices: [
      "$0-5k",
      "$5-10k",
      "$10-20k",
      "$20-50k",
      "$50-100k",
      "$100-250k",
      "$250-500k",
      "$500k+",
    ],
  },
  {
    number: 8,
    id: "start_timeline",
    type: "choices",
    title: "How soon are you looking to start?",
    description: "Select when you are ready to Unlock The Matrix",
    choices: ["Immediately", "Within a month", "Within 3 months", "Just exploring"],
  },
  {
    number: 9,
    id: "scheduled_call",
    type: "scheduler",
    title: "Schedule your Enrollment Call",
    description: "See if you qualify to become part of The Matrix Unlocked.",
  },
];
